export var LOCAL = 'local';
export var URL = 'url';
export var CAMERA = 'camera';
export var DROPBOX = 'dropbox';
export var FACEBOOK = 'facebook';
export var GDRIVE = 'gdrive';
export var GPHOTOS = 'gphotos';
export var INSTAGRAM = 'instagram';
export var UPLOAD_CARE_WIDGET_TYPE = {
  MINIMAL: 'minimal',
  REGULAR: 'regular'
};
export var MAX_LOCAL_FILE_SIZE_BYTES = 10000000;
export var UPLOAD_CARE_SOURCE_LIST_DEFAULT = "".concat(LOCAL, ", ").concat(URL, ", ").concat(CAMERA, ", ").concat(FACEBOOK, ", ").concat(INSTAGRAM);
export var UPLOAD_CARE_CSS_SRC = 'https://cdn.jsdelivr.net/npm/@uploadcare/blocks@0.35.2/web/lr-file-uploader-regular.min.css';